import Client from "../Util/client";
import config from "../config";
import { navigate } from "gatsby-link";
import { STORAGE_KEY } from "../constants";
import {closeDialog,showLoading,Util} from "baziigram";
import {showLoginDialog} from "../pages/Login"
import {UpdateUser,GetUser} from "../Util/user"
import {dictionary} from "../constants"
import {openForgetDialog } from '../Handlers/Dialogs'

const clearUser = (request) => {
    if(typeof window !== 'undefined')
    UpdateUser(null)
    showLoading(false)
    closeDialog()
    if(request.status==401)
    showLoginDialog()

    else
    openForgetDialog("generalForgetfulnessText")

};

export const updateToken = async (request, retryCount = 3 , timeout=2000) => {
setTimeout(()=>{
    let refreshToken = GetUser().refreshToken;
    let language = Util.getLanguage();
    if (refreshToken) {
        return RefreshToken(refreshToken)
            .then(res => {
           UpdateUser({"accessToken":res.accessToken , "refreshToken":res.refreshToken})
           setTimeout(()=>{
              client.proccessQueue(res.accessToken)
               },timeout)
            })
            .catch(err => {
            if (retryCount > 0) {
                    retryCount--;
                    return setTimeout(()=>updateToken(request, retryCount),timeout);
                } else {
                    clearUser(request);
                    //throw err;
                }
            });
    } else {
        clearUser(request);
    }
    },timeout)
};

const client = new Client(
    config.app.service.baseUrl,
    {},
    {},
    updateToken,
    config.app.service.timeout,
    {}
);

const RefreshToken = require("./app.service.refresh_token").default(client)

const GetGamesList = require("./app.service.get_game_list").default(client);


const RecordSiteView = require('./app.service.record_site_view').default(client)
const UnlockUser = require('./app.service.unlock_user').default(client)
const GetBanners = require('./app.service.get_banners').default(client)
const GetNews = require('./app.service.get_news').default(client)
const GetAchivements = require('./app.service.get_achivements').default(client)
const GetLevelInfo = require('./app.service.get_level_info').default(client)
const BuyAchievement = require("./app.service.buy_achievement").default(client)
const GameUserLogin = require("./app.service.user_login").default(client)
const GameUserVerify = require("./app.service.user_verify").default(client)
const GameEditProfile = require("./app.service.user_edit_profile").default(client)
const GetGameUserProfile = require("./app.service.get_user_profile").default(client)
const GetLeaderboard = require("./app.service.get_leaderboard").default(client)
const GetUserPrizes = require("./app.service.get_user_prizes").default(client)
const GetAwardsList = require("./app.service.get_awards_list").default(client)
const GetPrize = require("./app.service.get_prize").default(client)
const GetGroups = require("./app.service.get_groups").default(client)
const GetJoinRequests = require("./app.service.get_join_requests").default(client)
const CreateNewGroup = require("./app.service.create_new_group").default(client)
const GetChats = require("./app.service.get_chats").default(client)
const NotifyAdmin = require("./app.service.notify_admin").default(client)
const GameAlternativeLog = require("./app.service.alternative_log").default(client)
const GameOffers=require("./app.service.game_offers").default(client)
const GetDeveloperInfo=require("./app.service.developer_info").default(client)
const AdsLog = require("./app.service.record_ad_log").default(client)
const GetGameCategories = require("./app.service.get_game_categories").default(client)
const GetLevels = require("./app.service.get_levels").default(client)
const FCMToken = require("./app.service.set_fcm_token").default(client)
export default {
    RefreshToken,
    GetGamesList,
    RecordSiteView,
    UnlockUser,
    GetBanners,
    GetNews,
    GetAchivements,
    GetLevelInfo,
    BuyAchievement,
    GameUserLogin,
    GameUserVerify,
    GameEditProfile,
    GetGameUserProfile,
    GetLeaderboard,
    GetUserPrizes,
    GetAwardsList,
    GetPrize,
    GetGroups,
    GetJoinRequests,
    CreateNewGroup,
    GetChats,
    NotifyAdmin,
    GameAlternativeLog,
    GameOffers,
    RefreshToken,
    GetDeveloperInfo,
    AdsLog,
    GetGameCategories,
    GetLevels,
    FCMToken
};
